/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ModelTypeEnum } from './ModelTypeEnum';
import { ModelTypeEnumFromJSON, ModelTypeEnumFromJSONTyped, ModelTypeEnumToJSON } from './ModelTypeEnum';

/**
 *
 * @export
 * @interface QuestionnaireAnswerCreate
 */
export interface QuestionnaireAnswerCreate {
  /**
   *
   * @type {number}
   * @memberof QuestionnaireAnswerCreate
   */
  aiModel: number;
  /**
   *
   * @type {number}
   * @memberof QuestionnaireAnswerCreate
   */
  datasetPipeline: number;
  /**
   *
   * @type {Array<number>}
   * @memberof QuestionnaireAnswerCreate
   */
  selectedRiskMetrics?: Array<number>;
  /**
   *
   * @type {Array<number>}
   * @memberof QuestionnaireAnswerCreate
   */
  styleCriteria?: Array<number>;
  /**
   *
   * @type {ModelTypeEnum}
   * @memberof QuestionnaireAnswerCreate
   */
  modelType?: ModelTypeEnum | null;
  /**
   *
   * @type {number}
   * @memberof QuestionnaireAnswerCreate
   */
  protectedGroupDataset?: number | null;
  /**
   *
   * @type {Array<number>}
   * @memberof QuestionnaireAnswerCreate
   */
  performanceMetrics: Array<number>;
  /**
   *
   * @type {number}
   * @memberof QuestionnaireAnswerCreate
   */
  reportType?: number | null;
  /**
   *
   * @type {Array<number>}
   * @memberof QuestionnaireAnswerCreate
   */
  insightfulnessCriteria?: Array<number>;
  /**
   *
   * @type {Array<number>}
   * @memberof QuestionnaireAnswerCreate
   */
  personalDataExposureCategories?: Array<number>;
}

/**
 * Check if a given object implements the QuestionnaireAnswerCreate interface.
 */
export function instanceOfQuestionnaireAnswerCreate(value: object): value is QuestionnaireAnswerCreate {
  if (!('aiModel' in value) || value['aiModel'] === undefined) return false;
  if (!('datasetPipeline' in value) || value['datasetPipeline'] === undefined) return false;
  if (!('performanceMetrics' in value) || value['performanceMetrics'] === undefined) return false;
  return true;
}

export function QuestionnaireAnswerCreateFromJSON(json: any): QuestionnaireAnswerCreate {
  return QuestionnaireAnswerCreateFromJSONTyped(json, false);
}

export function QuestionnaireAnswerCreateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): QuestionnaireAnswerCreate {
  if (json == null) {
    return json;
  }
  return {
    aiModel: json['ai_model'],
    datasetPipeline: json['dataset_pipeline'],
    selectedRiskMetrics: json['selected_risk_metrics'] == null ? undefined : json['selected_risk_metrics'],
    styleCriteria: json['style_criteria'] == null ? undefined : json['style_criteria'],
    modelType: json['model_type'] == null ? undefined : ModelTypeEnumFromJSON(json['model_type']),
    protectedGroupDataset: json['protected_group_dataset'] == null ? undefined : json['protected_group_dataset'],
    performanceMetrics: json['performance_metrics'],
    reportType: json['report_type'] == null ? undefined : json['report_type'],
    insightfulnessCriteria: json['insightfulness_criteria'] == null ? undefined : json['insightfulness_criteria'],
    personalDataExposureCategories:
      json['personal_data_exposure_categories'] == null ? undefined : json['personal_data_exposure_categories'],
  };
}

export function QuestionnaireAnswerCreateToJSON(value?: QuestionnaireAnswerCreate | null): any {
  if (value == null) {
    return value;
  }
  return {
    ai_model: value['aiModel'],
    dataset_pipeline: value['datasetPipeline'],
    selected_risk_metrics: value['selectedRiskMetrics'],
    style_criteria: value['styleCriteria'],
    model_type: ModelTypeEnumToJSON(value['modelType']),
    protected_group_dataset: value['protectedGroupDataset'],
    performance_metrics: value['performanceMetrics'],
    report_type: value['reportType'],
    insightfulness_criteria: value['insightfulnessCriteria'],
    personal_data_exposure_categories: value['personalDataExposureCategories'],
  };
}
